import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import { MENU } from 'bento-ordering/menus/constants/entities';

import { generatePath } from 'bento-ordering/utils/generatePath';
import { closeLocationDetailModal } from 'bento-ordering/locations/actions/locations';

import {
  fulfillmentOptions,
  ALL_ONLINE_ORDERING_FULFILLMENT_METHODS
} from 'bento-ordering/cart/constants/fulfillmentOptions';

import Modal from 'bento-ordering/base/ui_components/Modal';
import OrderSettingContainer from 'bento-ordering/menus/components/OrderSettingContainer';
import OrderAlertManager from 'bento-ordering/locations/components/OrderAlertManager';
import { toggleAlertStatus } from 'bento-ordering/base/actions/alertStatus';
import withOrderSetting from 'bento-ordering/base/hoc/withOrderSetting';
import withGoogleLibraryLoaded from 'bento-ordering/base/hoc/withGoogleLibraryLoaded';

class OrderSettingModal extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    alert: PropTypes.string,
    isAsapAvailableForPickup: PropTypes.bool,
    isAsapAvailableForDelivery: PropTypes.bool,
    nextAvailablePickupTime: PropTypes.object,
    nextAvailableDeliveryTime: PropTypes.object,
    fulfillmentMethod: PropTypes.oneOf([
      fulfillmentOptions.DELIVERY,
      fulfillmentOptions.PICKUP
    ]),
    today: PropTypes.string,

    cartWorkingCopy: PropTypes.object,
    availableFulfillmentOptions: PropTypes.arrayOf(
      PropTypes.oneOf(ALL_ONLINE_ORDERING_FULFILLMENT_METHODS)
    ),
    metaData: PropTypes.object
  };

  /**
   * This same logic is used in Modal, OrderSettingModal, LocationDetailModal.
   * If the user close the modal we want to do the following:
   * 1) reset to the original fulfillment options
   * 2) reset the logic to determine if cart items are available
   * 3) close and reset any alerts
   */
  closeModal = () => {
    const { match, history, dispatch, alert } = this.props;
    dispatch(
      closeLocationDetailModal(() => {
        const slug = match.params.slug;
        history.push(generatePath(MENU, 'menu', { slug }));
      })
    );
    // close open alert
    dispatch(toggleAlertStatus(alert));
  };

  render() {
    const {
      alert,
      isAsapAvailableForPickup,
      isAsapAvailableForDelivery,
      nextAvailablePickupTime,
      nextAvailableDeliveryTime,
      fulfillmentMethod,
      today,
      cartWorkingCopy,
      availableFulfillmentOptions,
      metaData
    } = this.props;
    return (
      <Modal
        onClose={this.closeModal}
        alert={alert}
        alertComponent={
          <OrderAlertManager
            alert={alert}
            metaData={metaData}
            fulfillmentMethod={fulfillmentMethod}
            pickupTime={get(nextAvailablePickupTime, 'open_time')}
            pickupDate={get(nextAvailablePickupTime, 'date')}
            deliveryTime={get(nextAvailableDeliveryTime, 'open_time')}
            deliveryDate={get(nextAvailableDeliveryTime, 'date')}
            isAsapAvailableForPickup={isAsapAvailableForPickup}
            isAsapAvailableForDelivery={isAsapAvailableForDelivery}
            today={today}
            cartWorkingCopy={cartWorkingCopy}
            availableFulfillmentOptions={availableFulfillmentOptions}
          />
        }
      >
        <OrderSettingContainer
          closeModal={this.closeModal}
          isAsapAvailableForPickup={isAsapAvailableForPickup}
          isAsapAvailableForDelivery={isAsapAvailableForDelivery}
        />
      </Modal>
    );
  }
}

export default withRouter(
  withGoogleLibraryLoaded(withOrderSetting(OrderSettingModal))
);
